import React, { useEffect, useState, useRef, CSSProperties } from 'react';
import { Button, FormInstance, Modal, Row, message } from 'antd';
import { CloseOutlined, PlusCircleTwoTone } from '@ant-design/icons';
import './index.scss';
import CommonForm from '../CommonForm';
import RemoteCallApi from './service';
import { HttpStatusCode } from '@/fetch/core/constant';
import { debounce } from '@/utils/util';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
interface Props {
  vehicleName: string;
  visible: boolean;
  setVisible: AnyFunc;
  disabled?: boolean;
  size?: SizeType;
  style?: CSSProperties;
}

interface RemoteCallFormProps {
  formInstance: any;
  wordList: {
    id: number;
    content: string;
  }[];
  setWordList: AnyFunc;
}

const requestApi = new RemoteCallApi();

const formConfig: FormConfig = {
  data: [
    {
      cmpType: 'textarea',
      fieldName: 'content',
      label: '喊话内容',
      placeholder: '请填写喊话内容',
      maxLength: 30,
      validatorRules: [
        {
          required: true,
          message: '请先输入喊话内容~',
        },
        {
          type: 'string',
          max: 30,
        },
      ],
    },
  ],
};

const RemoteCallForm = (props: RemoteCallFormProps) => {
  const [visible, setVisible] = useState(false);
  const { formInstance, wordList, setWordList } = props;

  useEffect(() => {
    getWordList();
  }, []);

  const getWordList = async () => {
    try {
      const res = await requestApi.getWordList();
      if (res?.code === HttpStatusCode.Success) {
        setWordList(res.data);
      } else {
        message.error('获取常用语列表失败');
      }
    } catch {}
  };

  const addWord = async () => {
    try {
      if (formInstance.current) {
        const formValue = await formInstance.current.validateFields();

        const res = await requestApi.addWord(formValue.content);
        if (res?.code === HttpStatusCode.Success) {
          getWordList();
          message.success('添加常用语成功！');
          setVisible(true);
        }
      }
    } catch {
      message.error('请先输入喊话内容~');
    }
  };

  const removeWord = async (id: number) => {
    try {
      const res = await requestApi.deleteWord(id);
      if (res?.code === HttpStatusCode.Success) {
        getWordList();
        message.success('常用语删除成功～');
      } else {
        message.error('常用语删除失败');
      }
    } catch {}
  };

  return (
    <>
      <CommonForm
        config={formConfig}
        layout={'horizontal'}
        labelAlign="left"
        getFormInstance={(formRef: FormInstance) => {
          formInstance.current = formRef;
        }}
      />
      <Row className="operation_area">
        <Button className="custom_round_btn" onClick={addWord}>
          <PlusCircleTwoTone twoToneColor={'#0D85FF'} />
          添加常用语
        </Button>
      </Row>
      <Row className="collected_word_list">
        <div className="label">常用语</div>
        <div className="list_area">
          {wordList.map(
            (
              item: {
                id: number;
                content: string;
              },
              index: number
            ) => {
              return (
                <div
                  className="word"
                  key={item.id}
                  onClick={async () => {
                    try {
                      if (formInstance.current) {
                        const formValue =
                          formInstance.current.getFieldValue('content');

                        formInstance.current.setFieldValue(
                          'content',
                          formValue ? formValue + item.content : item.content
                        );
                        await formInstance.current.validateFields();
                      }
                    } catch {}
                  }}
                >
                  <span className="word_content">{item.content}</span>
                  <span className="delete_icon">
                    <CloseOutlined
                      onClick={(e) => {
                        e.stopPropagation();
                        removeWord(item.id);
                      }}
                    />
                  </span>
                </div>
              );
            }
          )}
        </div>
      </Row>
    </>
  );
};

const RemoteCallModal = (props: Props) => {
  const { vehicleName, disabled, size, style, visible, setVisible } = props;
  const [wordList, setWordList] = useState<
    {
      id: number;
      content: string;
    }[]
  >([
    {
      id: 1,
      content: 'Hello',
    },
  ]);
  const formInstance = useRef<any>(null);

  const sendRemoteCall = debounce(async () => {
    try {
      if (formInstance.current) {
        const formValue = await formInstance.current.validateFields();
        const res = await requestApi.sendRemoteCall({
          vehicleName: vehicleName,
          message: formValue.content,
        });

        if (res?.code === HttpStatusCode.Success) {
          message.success('下发远程喊话指令成功！');
        } else {
          message.error('发送远程喊话指令失败');
        }
      }
    } catch (err) {
      console.log(err);
    }
  }, 500);
  return (
    <>
      {visible ? (
        <Modal
          width={1000}
          maskClosable={false}
          visible={visible}
          title="远程喊话"
          destroyOnClose
          onCancel={() => setVisible(false)}
          onOk={sendRemoteCall}
          style={style}
        >
          <RemoteCallForm
            wordList={wordList}
            setWordList={setWordList}
            formInstance={formInstance}
          />
        </Modal>
      ) : (
        ''
      )}
    </>
  );
};
export default React.memo(RemoteCallModal);
